import React, { Component, ElementType, ReactNode } from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { sendSignalsAction } from 'src/redux/componentSignals/actions';
import { toggleSignalsAction } from 'src/redux/componentSignals/actions';
import type { RootState } from 'src/redux/store';

export const SHOW = 'SHOW';

interface WrapperProps {
  display?: boolean;
  children?: ReactNode;
  setSignalToToggle: () => void;
}

interface WrapperOwnProps {
  targetId: string;
  visible?: boolean;
}

export class DisplayWrapperComponent extends Component<WrapperProps> {
  componentDidMount() {
    this.props.setSignalToToggle();
  }
  render() {
    return this.props.display && this.props.children;
  }
}

export const mapStateToWrapperProps = (
  state: RootState,
  ownProps: WrapperOwnProps,
) => {
  let display = false;
  try {
    display = !!(state.componentSignals as any)?.[ownProps.targetId]?.[SHOW];
  } catch (e) {
    console.log('Error', e);
  }
  return { display: display };
};

export const mapDispatchToWrapperProps = (
  dispatch: Dispatch,
  ownProps: WrapperOwnProps,
) => {
  return {
    setSignalToToggle: () => {
      dispatch(
        sendSignalsAction({
          [ownProps.targetId]: { [SHOW]: !!ownProps.visible },
        }),
      );
    },
  };
};

export const DisplayWrapper = connect(
  mapStateToWrapperProps,
  mapDispatchToWrapperProps,
)(DisplayWrapperComponent);

interface ToggleProps {
  component: ElementType;
  targetId?: string;
  children?: ReactNode;
  toggleDisplayComponent?: () => void;
  [key: string]: any;
}

export class DisplayToggleWrapperComponent extends Component<ToggleProps> {
  render() {
    const {
      component: _component,
      targetId: _targetId,
      children,
      toggleDisplayComponent,
      ...rest
    } = this.props;
    const PresentationComponent = this.props.component;
    return (
      <PresentationComponent {...rest} onClick={toggleDisplayComponent}>
        {children}
      </PresentationComponent>
    );
  }
}

export const mapDispatchToPropsToggle = (
  dispatch: Dispatch,
  ownProps: { targetId: string },
) => {
  return {
    toggleDisplayComponent: () => {
      dispatch(toggleSignalsAction({ [ownProps.targetId]: [SHOW] }));
    },
  };
};

export const DisplayToggleWrapper = connect(
  undefined,
  mapDispatchToPropsToggle,
)(DisplayToggleWrapperComponent);
